// src/theme/setThemeVars.js
const hexToRgb = (hex) => {
  let h = hex?.replace("#","") || "000000";
  if (h.length === 3) h = h.split("").map((c)=>c+c).join("");
  const n = parseInt(h, 16);
  return { r:(n>>16)&255, g:(n>>8)&255, b:n&255 };
};
const luminance = ({r,g,b}) => {
  const s=[r,g,b].map(v=>{v/=255;return v<=0.03928?v/12.92:Math.pow((v+0.055)/1.055,2.4);});
  return 0.2126*s[0]+0.7152*s[1]+0.0722*s[2];
};
const bestText = (rgb) => {
  const L=luminance(rgb), w={r:255,g:255,b:255}, b={r:0,g:0,b:0};
  const cW=(Math.max(L,luminance(w))+0.05)/(Math.min(L,luminance(w))+0.05);
  const cB=(Math.max(L,luminance(b))+0.05)/(Math.min(L,luminance(b))+0.05);
  return cW>=cB?w:b;
};
const rgbCss = ({r,g,b}) => `${r} ${g} ${b}`;

export const setThemeVars = (
  primaryHex = "#007AC9",
  secondaryHex = "#FB923C",
  btnHex = "#007AC9",
  btnHex2 = "#4BABE9"
) => {
  const root = document.documentElement;
  const p = hexToRgb(primaryHex);
  const s = hexToRgb(secondaryHex);
  const b1 = hexToRgb(btnHex);
  const b2 = hexToRgb(btnHex2);

  root.style.setProperty("--color-primary", rgbCss(p));
  root.style.setProperty("--color-on-primary", rgbCss(bestText(p)));
  root.style.setProperty("--color-secondary", rgbCss(s));
  root.style.setProperty("--color-on-secondary", rgbCss(bestText(s)));

  root.style.setProperty("--color-btn-primary", rgbCss(b1));
  root.style.setProperty("--color-btn-primary-2", rgbCss(b2));
  root.style.setProperty("--color-on-btn-primary", rgbCss(bestText(b1)));

  // compat éventuelle
  root.style.setProperty("--primary-color", primaryHex);
};

export const setDarkClass = (enabled) => {
  document.documentElement.classList.toggle("dark", !!enabled);
  document.documentElement.style.colorScheme = enabled ? "dark" : "light";
};
